import { render, staticRenderFns } from "./RelatorioTaxaAdministracaoRetrato.vue?vue&type=template&id=42bf5040"
import script from "./RelatorioTaxaAdministracaoRetrato.vue?vue&type=script&lang=js"
export * from "./RelatorioTaxaAdministracaoRetrato.vue?vue&type=script&lang=js"
import style0 from "./RelatorioTaxaAdministracaoRetrato.vue?vue&type=style&index=0&id=42bf5040&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports